module.exports = __webpack_public_path__ + "static/img/fix_back.73c92b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/fix_back.jpg?20181011
// module id = 64LF
// module chunks = 1